import stylesheet from './ReasonCardGroup.scss?inline';

import CustomComponent from "../../../base/customComponent/CustomComponent";
import Glide, {
    Anchors,
    Autoplay,
    Breakpoints,
    Controls,
    Images,
    Keyboard,
    Swipe
} from "../../../../../node_modules/@glidejs/glide/dist/glide.modular.esm";

class NXTReasonCardGroup extends CustomComponent {
    glide: Glide;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'reason-card-group',
        );
        container.innerHTML = `
            <div class="glide">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides"></ul>
                </div>

                <div class="reason-bullets glide__bullets" data-glide-el="controls[nav]"></div>
            </div>
        `;
        const glideContainer: HTMLElement = container.querySelector('.glide');
        const glideSlides: HTMLElement = glideContainer.querySelector('.glide__slides');
        const glideBullets: HTMLElement = glideContainer.querySelector('.glide__bullets');
        this.cloneReasonCardsIntoContainer(glideSlides, glideBullets);
        window.addEventListener('load', () => {
            this.glide = new Glide(glideContainer, {
                rewind: false,
            }).mount({
                Anchors, Autoplay, Breakpoints, Controls, Images, Keyboard, Swipe
            });
        });
        return container;
    }

    cloneReasonCardsIntoContainer(containerElement: HTMLElement, bulletContainer: HTMLElement) {
        const slotElements = this.getSlotElements('');
        slotElements.forEach((content, glideDir) => {
            content.removeAttribute('slot');
            // Add Reason Card
            const wrapper = document.createElement('li');
            wrapper.classList.add('glide__slide');
            wrapper.appendChild(content)
            containerElement.appendChild(wrapper);
            // Add Bullet
            const bullet = document.createElement('button');
            bullet.classList.add('glide__bullet');
            bullet.dataset.glideDir = `=${glideDir}`;
            bulletContainer.appendChild(bullet);
        });
    }

}

customElements.define('nxt-reason-card-group', NXTReasonCardGroup);
